import enLocale from 'element-ui/lib/locale/lang/en'; // 引入element语言包

const en = {
  Multilingual: {
    // 菜单
    transportManagement: 'Transport Management',
    transportList: 'Transport List',
    systemManagement: 'System Management',
    role: 'Role',
    accountManagement: 'Account',
    account: 'Account',
    accountType: 'Account Type',
    transportMonitoring: 'Transport Monitoring',
    transportOrder: 'Transport Order',
    groupManagement: 'Group Management',
    groupDevice: 'Group Device',
    processManagement: 'Process Management',
    iceboxProcess: 'Icebox Process',
    equipmentManagement: 'Equipment Management',
    deviceList: 'Device List',
    deviceType: 'Device Type',
    gatewayList: 'Gateway List',
    deviceParameters: 'Device Parameters',
    deviceEvent: 'Device Event',
    deviceMonitoring: 'Device Monitoring',
    assetData: 'Asset Data',
    asset: 'Asset Management',
    warehouseManagement: 'Warehouse',
    location: 'Location',
    refrigeratorManagement: 'Refrigerator',
    boxManagement: 'Box',
    box: 'Box',
    icebox: 'Icebox',
    iceboxShelf: 'Icebox Shelf',
    iceboxPallet: 'Icebox Pallet',
    vehicleManagement: 'Vehicle',
    mobileColdStorageManagement: 'Mobile Cold Storage',
    mobileShelter: 'Mobile Shelter',
    alarmManagement: 'Alarm Management',
    alarmInfoManagement: 'Alarm Info',
    alarmProjectManagement: 'Alarm Project',
    companyManagement: 'Company',
    siteManagement: 'Site',
    companySms: 'Company SMS',
    smsRecords: 'SMS Records',
    companyVoice: 'Company Voice',
    voiceRecord: 'Voice Record',
    deviceService: 'Device Service',
    globalConfig: 'Global Config',
    operationLog: 'Operation Log',
    iceboxLog: 'Icebox Log',
    userCenter: 'User Center',
    processTime: 'Process Time',
    monitoringDevice: 'Monitoring Device',
    dataBackup: 'Data Backup',
    // 界面
    transportationManagement: 'Transportation Management',
    company: 'Company',
    pleaseSelectACompany: 'Please Select A Company',
    site: 'Site',
    pleaseSelectASite: 'Please Select A Site',
    deviceNumber: 'Device Serial No',
    boxName: 'Box Name',
    deliveryOrderNumber: 'Order Number',
    orderNumber: 'Order Number',
    combinedOrderNumber: 'Combined Order Number',
    shipper: 'Shipper',
    carrier: 'Carrier',
    consignee: 'Consignee',
    coldChainTrackingOrder: 'Tracking Order',
    coldChainTrackingOrderNumber: 'Order Number',
    deliveryTime: 'Delivery Time',
    pleaseSelectTheStartTime: 'Please Select The Start Time',
    pleaseSelectTheEndTime: 'Please Select The End Time',
    receivingTime: 'Receiving Time',
    returnTime: 'Return Time',
    deviceSerialNumber: 'Device Serial No',
    waybillNumber: 'Transport Order Number',
    orderCreatedTime: 'Order Created Time',
    transportOrderNumberCombinedWithOrderNumber: 'Transport Order Number Combined With Order Number',
    startTime: 'Start Time',
    stopTime: 'Stop Time',
    endTime: 'End Time',
    overtemperatureState: 'Over Temp State',
    returnStatus: 'Return Status',
    operation: 'Operation',
    exportReport: 'Export Report',
    edit: 'Edit',
    checkIcebox: 'Check Icebox',
    sensorData: 'Sensor Data',
    modifyTransportTime: 'Modify Transport Time',
    cancel: 'Cancel',
    confirm: 'Confirm',
    noDataYet: 'No Data Yet',
    reviewSensorData: 'Review Sensor Data',
    viewSelectedSensorInformationInLineChart: 'View Selected Sensor Information In Line Chart',
    groupList: 'Group List',
    realTimeData: 'Real-Time Data',
    dataCurve: 'Data Curve',
    equipmentTrack: 'Device Track',
    dataAlarm: 'Data Alarm',
    dataReport: 'Data Report',
    enterCompanyNameToSearch: 'Enter Company Name To Search',
    pleaseEnterAtLeast4CharactersToSearch: 'Please Enter At Least 4 Characters To Search',
    onlineStatus: 'Online Status',
    transportationStatus: 'Transportation Status',
    temperature: 'Temperature',
    power: 'Power',
    wirelessSignal: 'Wireless Signal',
    gpsSignal: 'GPS Signal',
    humidity: 'Humidity',
    collectionTime: 'Collection Time',
    updateTime: 'Update Time',
    drawing: 'Drawing',
    humidityCurve: 'Humidity Curve',
    pleaseSelectTheDeviceListOnTheLeft: 'Please Select The Device List On The Left',
    tracePlayback: 'Trace Playback',
    pleaseSelectTheIntermediateDeviceList: 'Please Select The Intermediate Device List',
    alarmTime: 'Alarm Time',
    serialNumber: 'Device Serial No',
    sensorName: 'Sensor Name',
    alarmType: 'Alarm Type',
    alarmValue: 'Alarm Value',
    currentStatus: 'Current Status',
    currentDevice: 'Current Device',
    queryReportList: 'Query Report',
    WaybillMonitor: 'Transport Order Monitor',
    precooledTime: 'Precooled Time',
    coldReleasingTime: 'Cold Releasing Time',
    exportDataReportAccordingToTheTimeOnTheLeft: 'Export Data Report According To The Time On The Left',
    timePeriod: 'Time Period',
    orderStatusFilter: 'Order Status Filter',
    addWaybill: 'Add Transport Order',
    exportWaybill: 'Export Transport Order',
    importWaybillsInBatches: 'Import Transport Orders In Batches',
    issuingWarehouse: 'Issuing Warehouse',
    destinationWarehouse: 'Destination Warehouse',
    receivingWarehouse: 'Receiving Warehouse',
    receipt: 'Receipt',
    waybillReport: 'Transport Order Report',
    modelNo: 'Model No.',
    icePackLaserCode: 'Ice-Pack Laser Code',
    boxLaserCode: 'Box Laser Code',
    receiveTime: 'Receive Time',
    laserCode: 'Laser Code',
    sensor: 'Sensor',
    endTransport: 'End Transport',
    startTransport: 'Start Transport',
    stopTransport: 'Stop Transport',
    duplicatePackagingInformation: 'Duplicate Packaging Information',
    theModelOfTheBox: 'The Model Of The Box',
    groupName: 'Group Name',
    maximumTemperature: 'Maximum Temp',
    minimumTemperature: 'Minimum Temp',
    totalIcebox: 'Total Icebox',
    iceboxToBePrecooled: 'Icebox To Be Precooled',
    iceboxInPrecooling: 'Icebox In Precooling',
    preCooledIceBox: 'Pre-Cooled Ice Box',
    iceboxInTransport: 'Icebox In Transport',
    unrecycledIcebox: 'Unrecycled Icebox',
    toBePreCooled: 'To Be Pre-Cooled',
    preCooling: 'Pre-Cooling',
    inTransport: 'In Transport',
    transportCompleted: 'Transport Completed',
    preCoolingCompleted: 'Pre-Cooling Completed',
    coldReleasing: 'Cold Releasing',
    coldReleasingCompleted: 'Cold Releasing Completed',
    coldReleasingForTooLong: 'Cold Releasing For Too Long',
    carrierNumber: 'Carrier Number',
    totalSensors: 'Total Sensors',
    availableSensors: 'Available Sensors',
    inServiceSensors: 'In-Service Sensors',
    recyclableSensors: 'Recyclable Sensors',
    deviceAllocation: 'Device Allocation',
    offline: 'Offline',
    online: 'Online',
    servicePeriod: 'Service Period',
    calibrationDueDate: 'Calibration Due Date',
    firmwareVersion: 'Firmware Version',
    simNumber: 'SIM Number',
    siteList: 'Site List',
    remotePowerOff: 'Remote Power Off',
    samplingInterval: 'Sampling Interval',
    positioningInterval: 'Positioning Interval',
    communicationInterval: 'Communication Interval',
    recordingDelay: 'Recording Delay',
    powerAlarmValue: 'Power Alarm Value',
    communicationShutdownValue: 'Communication Shutdown Value',
    accelerationValue: 'Acceleration Value',
    sendParameters: 'Send Parameters',
    modifyParametersInBatches: 'Modify Parameters In Batches',
    shutdownInBatches: 'Shutdown In Batches',
    cancelShutdownInBatches: 'Cancel Shutdown In Batches',
    eventNumber: 'Event Number',
    assetNumber: 'Asset Number',
    assetName: 'Asset Name',
    assetType: 'Asset Type',
    warehouse: 'Warehouse',
    storageLocation: 'Storage Location',
    refrigerator: 'Refrigerator',
    insulatedBox: 'Insulated Box',
    mobileInsulatedShelter: 'Mobile Insulated Shelter',
    mobileColdStorage: 'Mobile Cold Storage',
    vehicle: 'Vehicle',
    assetList: 'Asset List',
    realTimeBoundDevice: 'Real-Time Bound Device',
    historicalBoundDevice: 'Historical Bound Device',
    track: 'Track',
    remainingBattery: 'Remaining Battery',
    wirelessSignalStrength: 'Wireless Signal Strength',
    gpsSignalStrength: 'GPS Signal Strength',
    bindingDevice: 'Binding Device',
    unbindingDevice: 'Unbinding Device',
    duration: 'Duration',
    capacity: 'Capacity',
    temperatureRange: 'Temp Range',
    dimensionsLengthWidthAndHeight: 'Dimensions (Length, Width And Height)',
    temperatureZone: 'Temp Zone',
    warehouseLocation: 'Warehouse Location',
    areaType: 'Area Type',
    thisLocationIsUsedForIcePackProcess: 'This Location Is Used For Ice-Pack Process',
    warningWhenReachingTheLimitRangeWithinPercentage: 'Warning When Reaching Limit Range Within ',
    brand: 'Brand',
    addedBoxModel: 'Added Box Model',
    personInCharge: 'Person In Charge',
    personInChargePhoneNumber: 'Person In Charge Phone Number',
    addedIcePackModel: 'Added Ice-Pack Model',
    addedIcePackRack: 'Added Ice-Pack Rack',
    printBarcode: 'Print Barcode',
    addedIcePackTray: 'Added Ice-Pack Tray',
    barcode: 'Barcode',
    licensePlate: 'License Plate',
    alarmNumber: 'Alarm Number',
    alarmName: 'Alarm Name',
    restoreToNormalValue: 'Restore To Normal Value',
    correctiveMeasures: 'Corrective Measures',
    usedToAutomaticallyGenerateDefaultAlarmsForOrders: 'Used To Automatically Generate Default Alarms For Orders',
    addAlarmItems: 'Add Alarm Items',
    setDefault: 'Set Default',
    accountInformation: 'Account Information',
    landline: 'Landline',
    cellPhone: 'Cell Phone',
    disable: 'Disable',
    displayAccordingToOtherAssets: 'Display According To Other Assets',
    displayByASingleIcePack: 'Display By A Single Ice Pack',
    type: 'Type',
    operator: 'Operator',
    remainingSMS: 'Remaining SMS',
    loginDevice: 'Login Device',
    sealPattern: 'Seal Pattern',
    provinceMunicipality: 'Province/Municipality',
    locations: 'Locations',
    detailedLocation: 'Detailed Location',
    smsRecharge: 'SMS Recharge',
    topUp: 'Top Up',
    return: 'Return',
    sms: 'SMS',
    totalAmountOfSending: 'Total Amount Of Sending',
    sendSuccessfully: 'Send Successfully',
    numberOfSmsChargingEntries: 'SMS Charging Entries Number',
    voiceRecharge: 'Voice Recharge',
    numberOfVoiceMessage: 'Voice Message Number',
    voiceMessageMarginPieces: 'Voice Message Margin (Pieces)',
    numberOfVoiceBillingItems: 'Number Of Voice Billing Items',
    updateServicePeriod: 'Update Service Period',
    currentServicePeriod: 'Current Service Period',
    increaseServicePeriod: 'Increase Service Period',
    increasedPeriod: 'Increased Period',
    expiration: 'Expiration',
    configurationTimeOfIcePackProcessTime: 'Configuration Time Of Ice-Pack Process Time',
    emailConfiguration: 'Email Configuration',
    systemEmailAddress: 'System Email Address',
    emailPassword: 'Email Password',
    emailSendingServerAddress: 'Email Sending Server Address',
    emailSendingServerPort: 'Email Sending Server Port',
    noteItIsRecommendedToSendEmailsUsingSslPleaseFillInTheEmailServerAddressAndPortThatSupportsSsl: 'Note: It is recommended to send emails using SSL. Please fill in the email server address and port that supports SSL',
    associatedDevices: 'Associated Devices',
    shippingOrderNumber: 'Shipping Order Number',
    mergeOrderNumber: 'Merge Order Number',
    status: 'Status',
    batchDownload: 'Batch Download',
    smartColdChainManagementSystem: 'Cold Chain Management System',
    delete: 'Delete',
    back: 'Return',
    save: 'Save',
    enable: 'Enable',
    disabled: 'Disable',
    fullName: 'Full Name',
    email: 'Email',
    password: 'Password',
    remark: 'Remark',
    code: 'Code',
    boxType: 'Box Type',
    name: 'Name',
    address: 'Address',
    smsNumber: 'SMS Number',
    alarm: 'Alarm',
    warning: 'Warning',
    systemEmail: 'System Email',
    temperatureAlarm: 'Temp Alarm',
    temperatureWarning: 'Temp Warning',
    humidityAlarm: 'Humidity Alarm',
    humidityWarning: 'Humidity Warning',
    lowPowerAlarm: 'Low Power Alarm',
    powerAlarm: 'Power Alarm',
    alarmStrategy: 'Alarm Strategy',
    device: 'Device',
    passwordChange: 'Not filling in will not change the original password',
    pleaseSelectAccountType: 'Please Select Account Type',
    pleaseSelectTheAsset: 'Please Select The Asset',
    pleaseSelectTheDevice: 'Please Select The Device',
    pleaseSelectTheDeviceType: 'Please Select The Device Type',
    PleaseChooseATimeZone: 'Please Choose A Time Zone',
    pleaseSelectTheAssetType: 'Please Select The Asset Type',
    recoverStatus: 'Recover Status',
    recoverTime: 'Recover Time',
    recoverValue: 'Recover Value',
    faculty: 'Faculty',
    deviceName: 'Device Name',
    weChatReceivesUser: 'WeChat Receives User',
    username: 'Username',
    maxTemp1: 'Max Temp 1',
    minTemp1: 'Min Temp 1',
    maxTemp2: 'Max Temp 2',
    minTemp2: 'Min Temp 2',
    maxTemp3: 'Max Temp 3',
    minTemp3: 'Min Temp 3',
    maxHumidity: 'Max Humidity',
    minHumidity: 'Min Humidity',
    sampleInterval: 'Sample Interval',
    locateInterval: 'Locate Interval',
    msgInterval: 'Communication Interval',
    recordDelay: 'Record Delay',
    batteryAlarmValue: 'Battery Alarm Value',
    batteryOff: 'Battery Off',
    acceleration: 'Acceleration',
    time: 'Time',
    avatar: 'Avatar',
    creating: 'Creating',
    created: 'Created',
    createFailed: 'Create Failed',
    all: 'All',
    notIssued: 'Not Issued',
    issued: 'Issued',
    issuing: 'Issuing',
    receiver: 'Receiver',
    normal: 'Normal',
    overtemperature: 'Over Temp',
    deviceLogin: 'Device Login',
    contacts: 'Contacts',
    sealImage: 'Seal Image',
    barCode: 'Bar Code',
    province: 'Province',
    city: 'City',
    area: 'Area',
    bindTime: 'Bind Time',
    unbindTime: 'Unbind Time',
    iceboxNumber: 'Icebox Number',
    operationTime: 'Operation Time',
    timeZone: 'Time Zone',
    startTemperature: 'Start Temp',
    maxTemp: 'Max Temp',
    minTemp: 'Min Temp',
    warningInterval: 'Warning Interval',
    gpsSwitch: 'GPS Switch',
    alarmSetting: 'Alarm Setting',
    offlineAlarm: 'Offline Alarm',
    dimensions: 'Dimensions',
    internalDimensions: 'Internal Dimensions',
    powerSupply: 'Power Supply',
    uploadImg: 'Upload Img',
    buzzerSwitch: 'Buzzer Switch',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    modifyPersonalInformation: 'Modify Personal Information',
    logout: 'Logout',
    login: 'Login',
    changePassword: 'Change Password',
    basicInformation: 'Basic Information',
    search: 'Search',
    create: 'Create',
    accountSetting: 'Account Setting',
    export: 'Export',
    cancelDefault: 'Cancel Default',
    totalBox: 'Total Box',
    availableBoxes: 'Available Boxes',
    boxInTransit: 'Box In Transit',
    recyclableBox: 'Recyclable Box',
    boxModel: 'Box Model',
    detail: 'Detail',
    pushApi: 'Push Api',
    humidityRange: 'Humidity Range',
    to: 'To',
    longitude: 'Longitude',
    latitude: 'Latitude',
    group: 'Group',
    second: 'Second',
    autoRefresh: 'Auto Refresh',
    refreshInterval: 'Refresh Interval',
    year: 'Year',
    month: 'Month',
    day: 'Day',
    alarmOnceForEachAnomaly: 'Alarm once for each anomaly',
    theAlarmIsGeneratedOnceFor: 'The alarm is generated once for',
    consecutiveAbnormalTimes: 'consecutive abnormal times',
    theFirstAndThen: 'The first abnormal alarm is immediately reported once, and then the abnormal alarm is reported for:',
    normalReminder: 'The first abnormal alarm is immediately reported once, and then the abnormal alarm is reported for:',
    showGrouping: 'Show Grouping',
    onlyDisplayDevices: 'Only Display Devices',
    selectAll: 'Select All',
    iceBoxInfo: 'Ice Box Information',
    accountInfo: 'Account Information',
    wechatBind: 'WeChat Bind',
    pleaseAttention: 'Please pay attention to the official account first, and then scan the QR code above for binding',
    bindFinish: 'Binding Completed',
    weChatAlarm: 'Scan code to bind WeChat alarm',
    preferenceSettings: 'Preference Settings',
    bindWeChat: 'Bind WeChat',
    unbind: 'Unbind',
    alarmInfo: 'Alarm Information',
    check: 'Check',
    batchRead: 'Batch Read',
    batchRectification: 'Batch Rectification',
    refresh: 'Refresh',
    searchTrack: 'Search Track',
    bindToAsset: 'Bind To Asset',
    boxInfo: 'Box Information',
    carInfo: 'Car Information',
    coldStoreInfo: 'Cold Store Information',
    companyInfo: 'Company Information',
    accountAPTInfo: 'Account APT Information',
    deviceInfo: 'Device Information',
    deviceAlarmSetting: 'Device Alarm Setting',
    language: 'Language',
    pleaseChooseALanguage: 'Please Choose A Language',
    iceBoxTypeInfo: 'Ice Box Type Information',
    iceBoxType: 'Ice Box Type',
    carrierType: 'Carrier Type',
    overTime: 'Over Time',
    remainTime: 'Remain Time',
    pleaseEnterYourAccount: 'Please Enter Your Account',
    pleaseEnterYourPassword: 'Please Enter Your Password',
    pleaseEnterYourVerificationCode: 'Please Enter Your Verification Code',
    waybillInfo: 'Transport Order Information',
    welcome: 'Welcome',
    // 面包屑
    editAccount: 'Edit Account',
    addAccount: 'Add Account',
    accountDetail: 'Account Detail',
    setAccount: 'Set Account',
    editAlarmInfo: 'Edit Alarm Info',
    addAlarmInfo: 'Add Alarm Info',
    editBox: 'Edit Box',
    addBox: 'Add Box',
    boxDetail: 'Box Detail',
    boxTypeManage: 'Box Type Management',
    editBoxType: 'Edit Box Type',
    addBoxType: 'Add Box Type',
    editVehicle: 'Edit Vehicle',
    addVehicle: 'Add Vehicle',
    vehicleDetail: 'Vehicle Detail',
    coldStoreManage: 'Cold Store Management',
    editColdStore: 'Edit Cold Store',
    addColdStore: 'Add Cold Store',
    coldStoreDetail: 'Cold Store Detail',
    editCompany: 'Edit Company',
    addCompany: 'Add Company',
    companyDetail: 'Company Detail',
    editCompanyAPI: 'Edit Company API',
    addCompanyAPI: 'Add Company API',
    companySMSRecharge: 'Company SMS Recharge',
    companySMSRechargeHistory: 'Company SMS History',
    companyVoiceRecharge: 'Company Voice Recharge',
    companyVoiceRechargeHistory: 'Company Voice History',
    deviceManagement: 'Device Management',
    editDevice: 'Edit Device',
    addDevice: 'Add Device',
    deviceDetail: 'Device Detail',
    deviceBatchAssign: 'Device Batch Assign',
    gatewayDetail: 'Gateway Detail',
    editRefrigerator: 'Edit Refrigerator',
    addRefrigerator: 'Add Refrigerator',
    refrigeratorDetail: 'Refrigerator Detail',
    editGroup: 'Edit Group',
    addGroup: 'Add Group',
    editIceBox: 'Edit Ice Box',
    addIceBox: 'Add Ice Box',
    iceBoxDetail: 'Ice Box Detail',
    iceBoxProcess: 'Ice Box Process',
    iceBoxPallet: 'Ice Box Pallet',
    editIceBoxPallet: 'Edit Ice Box Pallet',
    addIceBoxPallet: 'Add Ice Box Pallet',
    iceBoxShelf: 'Ice Box Shelf',
    editIceBoxShelf: 'Edit Ice Box Shelf',
    addIceBoxShelf: 'Add Ice Box Shelf',
    iceBoxShelfDetail: 'Ice Box Shelf Detail',
    iceboxType: 'Ice Box Type',
    iceBoxTypeDetail: 'Ice Box Type Detail',
    editIceBoxType: 'Edit Ice Box Type',
    addIceBoxType: 'Add Ice Box Type',
    editWarehouse: 'Edit Warehouse',
    addWarehouse: 'Add Warehouse',
    warehouseDetail: 'Warehouse Detail',
    log: 'Log',
    logDetail: 'Log Detail',
    editShelter: 'Edit Shelter',
    addShelter: 'Add Shelter',
    shelterDetail: 'Shelter Detail',
    addSite: 'Add Site',
    editSite: 'Edit Site',
    siteDetail: 'Site Detail',
    config: 'Config',
    deviceData: 'Device Data',
    editTransportOrder: 'Edit Transport Order',
    addTransportOrder: 'Add Transport Order',
    transportOrderDetail: 'Transport Order Detail',
    transportOrderMonitor: 'Transport Order Monitor',
    downloadCenter: 'Download Center',
    voiceList: 'Voice List',
    pleaseEnterSerialNumber: 'Please Enter Serial Number',
    pleaseEnterName: 'Please Enter Name',
    pleaseEnterMark: 'Please Enter Mark',
    pleaseChooseStatus: 'Please Select Status',
    pleaseEnterBoxName: 'Please Enter Box Name',
    pleaseEnterLaserCode: 'Please Enter Laser Code',
    pleaseEnterCode: 'Please Enter Code',
    pleaseSelectType: 'Please Select Type',
    pleaseEnterLicensePlate: 'Please Enter License Plate',
    pleaseEnterCompanyName: 'Please Enter Company Name',
    pleaseSelectADeviceType: 'Please Select A Device Type',
    pleaseEnterDeviceName: 'Please Enter Device Name',
    pleaseEnterRFID: 'Please Enter RFID',
    temperatureStatus: 'Temp Status',
    minimumRefreshInterval: 'The minimum refresh interval is 30 seconds',
    pleaseEnterRefreshInterval: 'Please Enter Refresh Interval',
    pleaseEnterYear: 'Please Enter Year',
    pleaseEnterMonth: 'Please Enter Month',
    pleaseEnterDay: 'Please Enter Day',
    pleaseEnterGatewayName: 'Please Enter Gateway Name',
    checkedByDefault: 'If not checked by default, it will be in minutes. If checked, the selection box will be in seconds',
    minAndSecond: 'Minutes: 1-195, seconds: 10-59',
    minAndSecond2: 'Minutes: 1-65475, seconds: 10-59',
    valueBetween100And80: 'Values between -100 and 80',
    valueBetween0And100: 'Values between 0 and 100',
    valueBetween1And100: 'Values between 1 and 100',
    valueBetween0And65535: 'Values between 0 and 65535',
    valueBetween1And1000: 'Values between 1 and 1000',
    valueBetween1And1440: 'Values between 1 and 1440',
    valueBetween0And1440: 'Values between 0 and 1440',
    valueBetween200And1000: 'Values between -200 and 1000',
    valueBetween200And1400: 'Values between -200 and 1400',
    valueBetween100And100: 'Values between -100 and 100',
    pleaseSelectSampleInterval: 'Please Select Sample Interval',
    pleaseSelectMSGInterval: 'Please Select MSG Interval',
    upperLimit: 'Upper Limit',
    lowerLimit: 'Lower Limit',
    pleaseEnterGroupName: 'Please Enter Group Name',
    pleaseSelectIceBoxType: 'Please Select Ice Box Type',
    iceBoxTypeName: 'Ice Box Type Name',
    RFIDNumber: 'RFID Number',
    long: 'Long',
    width: 'Width',
    height: 'Height',
    pleaseSelectOperateType: 'Please Select Operate Type',
    operateType: 'Operate Type',
    assetCode: 'Asset Code',
    pleaseEnterAssetCode: 'Please Enter Asset Code',
    provinceMunicipalitySpecialAdministrativeRegion: 'Province/Municipality/Special Administrative Region',
    clickMap: 'Click on the map to automatically obtain the location',
    provideDetailedLocationInformation: 'Provide Detailed Location Information',
    enterDeviceSerialNumberSearch: 'Enter Device Serial Number Search',
    alarmMethod: 'Alarm Method',
    forceNoAlarm: 'Force No Alarm',
    accordingToAlarm: 'According to the alarm set in the Transport Order',
    pleaseSelectTransportStatus: 'Please Select Transport Status',
    clickToUpload: 'Click to upload',
    onlyFiles: 'Only files up to 20M in size can be uploaded',
    pleaseSelect: 'Please Select',
    content: 'Content',
    sendTime: 'Send Time',
    voiceNumber: 'Number Of Voice Billing Records',
    warehouseInfo: 'Warehouse Information',
    boxTypeInfo: 'Box Type Information',
    vehicleInfo: 'Vehicle Information',
    deviceBatchAllocation: 'Device Batch Allocation',
    refrigeratorInfo: 'Refrigerator Information',
    iceboxPalletInfo: 'Ice Box Pallet Information',
    iceBoxShelfInfo: 'Ice Box Shelf Information',
    createSubLocation: 'Create Sub Location',
    shelterInfo: 'Shelter Information',
    pleaseEnterCarrierNumber: 'Please Enter Carrier Number',
    modifyShippingTime: 'Modify Shipping Time',
    orderTime: 'Order Time',
    deleteDevice: 'Delete Device',
    batchAlarmSetting: 'Batch Alarm Setting',
    upperTemperatureLimit: 'Upper Temp',
    lowerTemperatureLimit: 'Lower Temp',
    upperHumidityLimit: 'Upper Humidity',
    lowerHumidityLimit: 'Lower Humidity',
    deleteSelected: 'Delete Selected',
    alarmProject: 'Alarm Project',
    boxprecooledTime: 'Box Precooled Time',
    deviceView: 'Device View',
    efficiency: 'Efficiency',
    hour: 'Hour',
    usedAutomatically: 'Used to automatically generate default alarms for orders',
    sMSMargin: 'SMS Margin',
    totalAmountSent: 'Total Amount Sent',
    sendSuccess: 'Send Success',
    items: 'Items',
    iceBoxLog: 'Ice Box Log',
    deviceAlarm: 'Device Alarm when offline',
    editSubLocation: 'Edit Sub Location',
    print: 'Print',
    userInfo: 'User Info',
    reset: 'Reset',
    uploadImgFile: 'Only JPG/PNG files can be uploaded, and they should not exceed 500kB',
    exportType: 'Export Type',
    fileStatus: 'File Status',
    download: 'Download',
    yes: 'Yes',
    no: 'No',
    exportReportInfo: 'Export Report Information',
    generating: 'Generating',
    generated: 'Generated',
    notSupportParameterSettings: 'The current type of device does not support parameter settings',
    channel: 'Channel',
    channelDetails: 'Channel Detail',
    vibration: 'Vibration',
    vibrationAlarm: 'Vibration Alarm',
    tilt: 'Tilt',
    tiltAlarm: 'Tilt Alarm',
    maxLight: 'Max Light',
    minLight: 'Min Light',
    lightAlarm: 'Light Alarm',
    remove: 'Remove',
    strategy: 'Strategy',
    operateTime: 'Operate Time',
    delayedDuration: 'Delayed Duration',
    seconds: 'Seconds',
    minutes: 'Minutes',
    pleaseEnterTheReceivingUnit: 'Please Enter The Receiving Unit',
    pleaseEnterTheHumidityLowerLimit: 'Please Enter The Humidity Lower Limit',
    pleaseEnterTheHumidityUpperLimit: 'Please Enter The Humidity Upper Limit',
    pleaseSelectTheReceivingUser: 'Please Select The Receiving User',
    pleaseEnterTheRectificationMeasure: 'Please Enter The Rectification Measure',
    noData: 'No Data',
    unitDefaultToMinutes: 'Unit default to minutes, when sampling interval is selected seconds, it must be consistent with the sampling interval, when sampling interval is not selected seconds, it should be a positive integer multiple of the sampling interval',
    transportOrderNumber: 'Transport Order Number',
    unitSeconds: 'Unit: Seconds',
    defaultToMinutes: 'Default to minutes, when sampling interval is selected seconds',
    valueBetweenMinus100And80: 'Values between -100 and 80',
    max20Characters: 'Max 20 Characters',
    selectDateTime: 'Select Date Time',
    endShipping: 'End Shipping',
    shippingEnd: 'Shipping End',
    shippingInProgress: 'Shipping In Progress',
    notShipped: 'Not Shipped',
    pleaseSelectTheIssuanceType: 'Please Select The Issuance Type',
    issuanceType: 'Issuance Type',
    allNodes: 'All Nodes',
    bindNode: 'Bind Node',
    specifiedNode: 'Specified Node',
    gateway: 'Gateway',
    nodeList: 'Node List',
    nodeList2: 'Node List (Max 20 Nodes)',
    issuanceParametersToSpecificNodesMustSelectNodes: 'Issuance parameters to specific nodes must select nodes',
    nodeSelectionQuantityCannotBeGreaterThan20CurrentSelectionQuantity: 'Node selection quantity cannot be greater than 20, current selection quantity',
    brightScreenTime: 'Bright Screen Time',
    normalUploadInterval: 'Normal Upload Interval',
    range1To1440: 'Range: 1-1440',
    associatedFenceCount: 'Associated Fence Count',
    flightModeDuration: 'Flight Mode Duration',
    exitFlightModeBeforeCommunicationInterval: 'Exit Flight Mode Before Communication Interval',
    flightModeStatus: 'Flight Mode Status',
    associateFence: 'Associate Fence',
    index: 'Index',
    radius: 'Radius',
    bindFence: 'Bind Fence',
    flightModeSetting: 'Flight Mode Setting',
    pleaseEnterFlightModeDuration: 'Please Enter Flight Mode Duration',
    pleaseEnterExitFlightModeBeforeCommunicationInterval: 'Please Enter Exit Flight Mode Before Communication Interval',
    fenceInfo: 'Fence Info',
    pleaseSelectAddress: 'Please Select Address',
    pleaseSelectFence: 'Please Select Fence',
    meter: 'Meter',
    fenceManagement: 'Fence Management',
    editFence: 'Edit Fence',
    newFence: 'New Fence',
    findPassword: 'Find Password',
    confirmAccount: 'Confirm Account',
    resetPassword: 'Reset Password',
    resetComplete: 'Reset Complete',
    pleaseEnterAccountBoundMobilePhoneNumberOrEmail: 'Please Enter Account Bound Mobile Phone Number Or Email',
    nextStep: 'Next Step',
    pleaseEnterNewPassword: 'Please Enter New Password',
    pleaseEnterNewPasswordAgain: 'Please Enter New Password Again',
    previousStep: 'Previous Step',
    goToLogin: 'Go To Login',
    congratulations: 'Congratulations',
    resetPasswordSuccess: 'Reset Password Success',
    shipmentID: 'Shipment ID',
    dataDetail: 'Data Detail',
    deviceTrack: 'Device Track',
    coordinateTotalNumber: 'Coordinate Total Number',
    clickCoordinateToGetAddress: 'Click Coordinate To Get Address',
    orderNo: 'Order No',
    shipmentList: 'Shipment List',
    loading: 'Loading',
    playSpeed: 'Play Speed',
    queryTrack: 'Query Track',
    trackPlay: 'Track Play',
    pause: 'Pause',
    continue: 'Continue',
    stop: 'Stop',
    sensorTrackView: 'Sensor Track View',
    lastHour: 'Last Hour',
    last2Hours: 'Last 2 Hours',
    last3Hours: 'Last 3 Hours',
    last24Hours: 'Last 24 Hours',
    last3Days: 'Last 3 Days',
    lastWeek: 'Last Week',
    last10Days: 'Last 10 Days',
    last15Days: 'Last 15 Days',
    lastMonth: 'Last Month',
    smsMargin: 'SMS Margin',
    modifyParameters: 'Modify Parameters',
    setDeviceAlarm: 'Set Device Alarm',
  },
  ...enLocale,
};

export default en;



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js